import {
  LOAD_LINE_INFORMATION_SUCCESS,
} from './actions'

const initialState = {
  lineInfo: null,
}

const lineInfo = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_LINE_INFORMATION_SUCCESS:{
      return {
        ...state,
        lineInfo : action.payload,
      }
    }
    default:
      return state
  }
}

export default lineInfo



// WEBPACK FOOTER //
// ./src/components/LineStudentRegister/reducer.js